<template>
  <nav class="tab-bar">
    <router-link :to="{ name: 'Feed' }" class="tab-bar__button">
      <svg xmlns="http://www.w3.org/2000/svg" width="29.25" height="23.211" viewBox="0 0 29.25 23.211"><path d="M29.024,14.546a1.484,1.484,0,0,1-2.045.473L14.626,7.3,2.272,15.02A1.485,1.485,0,0,1,.7,12.5l13.14-8.206a1.484,1.484,0,0,1,1.573,0L28.553,12.5A1.483,1.483,0,0,1,29.024,14.546Zm-4.779.8L15.413,9.83a1.484,1.484,0,0,0-1.573,0L5.007,15.346a1.482,1.482,0,0,0-.7,1.259V25.8A1.485,1.485,0,0,0,5.795,27.28h4.874A1.485,1.485,0,0,0,12.153,25.8V21.611a2.474,2.474,0,0,1,4.948,0v4.184a1.485,1.485,0,0,0,1.484,1.484h4.874a1.485,1.485,0,0,0,1.484-1.484V16.6A1.484,1.484,0,0,0,24.245,15.346Z" transform="translate(0 -4.069)" fill="currentColor"/></svg>
      <span class="tab-bar__button-indicator" v-if="activeSnacks && activeSnacks.length">
        {{ activeSnacks.length }}
      </span>
    </router-link>

    <router-link :to="{ name: 'Pet' }" class="tab-bar__button">
      <svg v-if="activePetType=== 'dog'" xmlns="http://www.w3.org/2000/svg" width="33" height="28.187" viewBox="0 0 33 28.187"><path d="M30.125,30.765a.62.62,0,0,0-.621.618,2.565,2.565,0,0,1-5.114-.012V30.116a3.327,3.327,0,0,0,1.977-2.724.873.873,0,0,0-.178-.714.6.6,0,0,0-.459-.227l-3.939-.009a.6.6,0,0,0-.461.225.876.876,0,0,0-.181.714,3.3,3.3,0,0,0,2,2.744v1.244a2.569,2.569,0,0,1-5.119-.011.62.62,0,1,0-1.239,0,3.7,3.7,0,0,0,3.786,3.6,3.88,3.88,0,0,0,3.188-1.625,3.872,3.872,0,0,0,3.176,1.639,3.7,3.7,0,0,0,3.8-3.588.62.62,0,0,0-.618-.621" transform="translate(-7.256 -11.426)" fill="currentColor"/><path d="M22.734,15.687a1.668,1.668,0,1,1-1.664-1.671,1.668,1.668,0,0,1,1.664,1.671" transform="translate(-8.383 -6.056)" fill="currentColor"/><path d="M50.675,5.206Q48.664.141,42.409.507c-.876.052-.865.411-.181,1.191,1.756,1.12,3.03,4.867,3.908,8.171.292,1.1,1.318,1.6,2.075,1.091C50,9.753,51.823,8.1,50.675,5.206" transform="translate(-18.033 -0.209)" fill="currentColor"/><path d="M2.8,10.873c.755.513,1.782.015,2.078-1.082.895-3.3,2.184-7.042,3.945-8.154C9.516.86,9.528.5,8.652.445Q2.4.06.366,5.107c-1.161,2.887.658,4.55,2.438,5.765" transform="translate(0 -0.18)" fill="currentColor"/><path d="M31.4,13.047c-.2-.837-.377-1.637-.546-2.409C30.2,7.678,29.643,5.122,28.2,3.212,26.543,1.03,24,.008,20.207,0c-3.979-.009-6.62,1.087-8.313,3.447A11.935,11.935,0,0,0,10.21,7.166c-.377,1.3-.668,2.77-.977,4.325-.1.514-.208,1.045-.32,1.59a17.2,17.2,0,0,0-.379,5.942,10.465,10.465,0,0,0,2.174,5.421,9.388,9.388,0,0,0,3.9,2.8,15.117,15.117,0,0,0,5.519.94,14.473,14.473,0,0,0,5.6-1,9.715,9.715,0,0,0,3.959-2.952,10.7,10.7,0,0,0,2.155-5.39,15.078,15.078,0,0,0-.445-5.8M24,8A1.668,1.668,0,1,1,22.33,9.665,1.667,1.667,0,0,1,24,8M20.136,26.224c-8.607-.019-10.845-5.248-9.3-12.746C12.282,6.463,12.531,2.1,19.8,1.967c-.537,5.087-.357,14.969,9.8,12.023,1.5,6.982-1.215,12.252-9.465,12.233" transform="translate(-3.639 0)" fill="currentColor"/><path d="M29.544,39.518c.069,1.572-.742,2.2-1.685,2.244s-1.662-.523-1.73-2.095.64-2.88,1.583-2.921,1.763,1.2,1.832,2.771" transform="translate(-11.289 -15.878)" fill="currentColor"/></svg>
      <svg v-if="activePetType=== 'cat'" xmlns="http://www.w3.org/2000/svg" width="40" height="32" viewBox="0 0 30 23.58"><path fill="currentColor" d="M10.3 16.39a.48.48 0 00-1 0A3.06 3.06 0 0015 18a3.06 3.06 0 005.65-1.64.48.48 0 00-.95 0 2.12 2.12 0 01-4.23.06.43.43 0 00.09-.1l1.68-2.25c.31-.42.14-.76-.38-.76h-3.72c-.52 0-.69.34-.38.76l1.67 2.25.1.1a2.12 2.12 0 01-4.23-.06"/><path fill="currentColor" d="M18.05 14.72a.55.55 0 000 .17.29.29 0 000 .13v.08a.26.26 0 00.27.24c.75-.07 1.52-.11 2.28-.11a22.8 22.8 0 018.08 1.46 1.27 1.27 0 00.43.09c.18 0 .23-.09.24-.14.06-.26-.46-.46-.52-.48a23.25 23.25 0 00-7.73-1.47 21.62 21.62 0 012.54-.14 23.23 23.23 0 013.62.28c.56.09 1.14.2 1.7.34a2.23 2.23 0 00.34 0c.25 0 .31-.1.32-.18 0-.26-.51-.39-.57-.41q-.86-.19-1.71-.33a24.27 24.27 0 00-3.7-.29 23.08 23.08 0 00-2.88.18 23 23 0 016.4-.9c.63 0 1.28 0 1.91.07h.15a.69.69 0 00.44-.11.18.18 0 000-.12c0-.27-.56-.32-.63-.32-.64-.06-1.28-.08-1.92-.08a23.26 23.26 0 00-9 1.77.26.26 0 00-.15.14M.77 13.44h.15c.63 0 1.28-.07 1.91-.07a23 23 0 016.4.9 23.08 23.08 0 00-2.88-.18 24.27 24.27 0 00-3.7.29q-.85.14-1.71.33c-.06 0-.6.15-.57.41 0 .08.07.18.32.18a1.42 1.42 0 00.34 0c.57-.14 1.14-.25 1.7-.34a23.23 23.23 0 013.62-.28 21.62 21.62 0 012.54.14 23.25 23.25 0 00-7.73 1.47c-.06 0-.58.22-.52.48 0 .05.06.14.24.14a1.27 1.27 0 00.43-.09 22.8 22.8 0 018.08-1.46c.76 0 1.53 0 2.28.11a.26.26 0 00.27-.24v-.13a.28.28 0 000-.13.55.55 0 000-.17.29.29 0 00-.15-.14 23.26 23.26 0 00-9-1.77c-.64 0-1.28 0-1.92.08-.07 0-.63 0-.63.32a.18.18 0 000 .12.69.69 0 00.44.11"/><path fill="currentColor" d="M5.63 16.33a.77.77 0 00-.69-.46H4.8a.58.58 0 00-.39.28.55.55 0 000 .47 10.14 10.14 0 002.64 3.78 11.85 11.85 0 008 3 11.85 11.85 0 008-3 10 10 0 002.66-3.75.59.59 0 000-.47.61.61 0 00-.38-.32h-.17a.72.72 0 00-.65.44A10.1 10.1 0 0115 22.1a10.12 10.12 0 01-9.37-5.77M4.37 12.73a.66.66 0 00.64-.58c.58-4.51 4.86-7.9 10-7.9s9.33 3.37 9.94 7.84a.68.68 0 00.69.58.63.63 0 00.45-.22.57.57 0 00.13-.44A9.77 9.77 0 0023 5.94 11.9 11.9 0 0015 3a11.9 11.9 0 00-7.95 3 9.74 9.74 0 00-3.26 6.11.59.59 0 00.13.45.6.6 0 00.45.23M4.72 6.64c0 .51.23.57.53.16a10.51 10.51 0 011.36-1.48 10.78 10.78 0 013.29-2c.47-.18.5-.47 0-.69a36.35 36.35 0 01-3.79-2c-1.85-1.13-1.71.52-1.67 1 .09 1.47.16 3 .24 5M20.09 3.31a10.78 10.78 0 013.29 2 9.87 9.87 0 011.35 1.49c.3.41.52.35.54-.16.08-2 .14-3.54.24-5 0-.5.18-2.15-1.67-1a37.38 37.38 0 01-3.79 2c-.46.22-.44.51 0 .69"/><path fill="currentColor" d="M11.52 8.74a1.2 1.2 0 101.2 1.2 1.2 1.2 0 00-1.2-1.2M18.72 11.14a1.2 1.2 0 001.2-1.2 1.19 1.19 0 00-1.19-1.2 1.2 1.2 0 000 2.4"/></svg>
    </router-link>

    <router-link :to="{ name: 'Search' }" class="tab-bar__button">
      <svg xmlns="http://www.w3.org/2000/svg" width="22.55" height="23.1" viewBox="0 0 22.55 23.1"><path d="M15.819,13.707A8.662,8.662,0,1,0,1.7,3.668,8.71,8.71,0,0,0,3.762,15.777a8.619,8.619,0,0,0,9.4.39l6.378,6.366A1.8,1.8,0,0,0,22.1,22.6a1.823,1.823,0,0,0,.066-2.569c-.022-.023-.043-.044-.066-.066ZM8.755,14.3A5.6,5.6,0,1,1,14.33,8.688,5.591,5.591,0,0,1,8.755,14.3Zm0,0" transform="translate(-0.109 0)" fill="currentColor"/></svg>
    </router-link>

    <router-link :to="{ name: 'Settings' }" class="tab-bar__button">
      <svg xmlns="http://www.w3.org/2000/svg" width="27" height="26.999" viewBox="0 0 27 26.999"><g transform="translate(-298.405 -82.626)"><path d="M317.866,90.7a4.526,4.526,0,1,1-4.526,4.526A4.527,4.527,0,0,1,317.866,90.7Z" transform="translate(-5.958 -3.22)" fill="currentColor"/><path d="M316.075,115.957a10.043,10.043,0,0,1-6.54-2.412,1.929,1.929,0,0,1-.677-1.466,4.565,4.565,0,0,1,4.587-4.564h5.267a4.558,4.558,0,0,1,4.58,4.564,1.924,1.924,0,0,1-.676,1.465A10.04,10.04,0,0,1,316.075,115.957Z" transform="translate(-4.17 -9.929)" fill="currentColor"/><path d="M311.9,82.626a13.5,13.5,0,1,0,13.5,13.5A13.515,13.515,0,0,0,311.9,82.626Zm0,24.965A11.465,11.465,0,1,1,323.37,96.126,11.478,11.478,0,0,1,311.9,107.591Z" fill="currentColor"/></g></svg>
    </router-link>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'activePetType',
      'activeSnacks',
    ]),
  },
};
</script>

<style>
.tab-bar {
  height: 3.4375rem;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  border-radius: .875rem .875rem 0 0;
  box-shadow: 0 -3px 6px rgba(0, 0, 0, .16);
  display: flex;
  z-index: 1;
}

.tab-bar__button {
  text-decoration: none;
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  color: var(--purple);
}

.tab-bar__button:before {
  content: '';
  width: 2rem;
  height: .1875rem;
  background-color: #f06b00;
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -1rem;
  opacity: 0;
  transition: opacity .2s ease-out;
}

.tab-bar__button.router-link-active {
  color: #f06b00;
}

.tab-bar__button.router-link-active:before {
  opacity: 1;
}

.tab-bar__button-indicator {
  position: absolute;
  left: calc(50% + .425rem);
  bottom: 50%;
  width: 1.25rem;
  height: 1.25rem;
  font-size: .875rem;
  line-height: 1;
  padding-top: .1875rem;
  border-radius: 50%;
  background-color: var(--blue);
  color: #fff;
}

@media (min-width: 640px) {
  .tab-bar {
    width: 36rem;
    border-radius: 2rem;
    padding-left: 2rem;
    padding-right: 2rem;
    left: 50%;
    bottom: .5rem;
    margin-left: -18rem;
  }
}

@media (min-height: 1000px) and (min-width: 640px) {
  .tab-bar {
    bottom: auto;
    top: 926px;
  }
}

@media (min-width: 50rem) and (min-height: 1000px) {
  .tab-bar {
    top: 940px;
  }
}
</style>
